export const css = {
	root: 'zJPm6Rf5',
	text: 'qFrjU6Cw',
	contained: 'DxaUQDNm',
	outlined: 'qZyxnQHq',
	popup: 'e-Kll3Jn',
	label: 'amPZCjhG',
	icon: 'vNmUwJzb',
	iconOnly: 'jnK8bACl',
	disabled: 'h6F3VFo9',
	dark: 'TLmnRyYa',
	' _key': 'mc-widgets/tools-button'
};

export default css;
